import { Circle, CircleDot, XCircle } from "lucide-react";
import { AnswerStatus } from "../../../core/store/useQuestionFiltersStore";
import FilterChip, { ChipTone } from "./FilterChip";
import FilterChipGroup from "./FilterChipGroup";

interface StatusOption {
  value: AnswerStatus;
  label: string;
  icon: JSX.Element;
  tone: ChipTone;
}

/**
 * Only "Incorretas" is red, because failure is what that option is about. The
 * other two are ordinary selections and use the standard treatment — colouring
 * "Todas" red beside "Incorretas" would read as a second error state (§23.6).
 */
const STATUS_OPTIONS: StatusOption[] = [
  {
    value: "unanswered",
    label: "Não respondidas",
    icon: <Circle aria-hidden="true" />,
    tone: "select",
  },
  {
    value: "wrong",
    label: "Incorretas",
    icon: <XCircle aria-hidden="true" />,
    tone: "danger",
  },
  {
    value: "all",
    label: "Todas",
    icon: <CircleDot aria-hidden="true" />,
    tone: "select",
  },
];

export interface FilterStatusGroupProps {
  value: AnswerStatus;
  onChange: (value: AnswerStatus) => void;
  labelledBy?: string;
}

export default function FilterStatusGroup({
  value,
  onChange,
  labelledBy,
}: FilterStatusGroupProps) {
  return (
    <FilterChipGroup role="radiogroup" labelledBy={labelledBy} ariaLabel="Status das questões">
      {STATUS_OPTIONS.map((option) => (
        <FilterChip
          key={option.value}
          role="radio"
          label={option.label}
          icon={option.icon}
          tone={option.tone}
          selected={value === option.value}
          onToggle={() => onChange(option.value)}
        />
      ))}
    </FilterChipGroup>
  );
}

export { STATUS_OPTIONS };
